export const APP_NAME = "SiPANJA"
export const APP_VERSION = "1.0.0"
export const APP_DESCRIPTION = "Sistem Informasi Prasarana Jalan"

export const TabTitle = (newTitle) => {
	return (document.title = `${newTitle}  - ${APP_NAME}`)
}
